
//texts
import TEXT from '../../../utils/text/prensa.json'
import miscTEXT from "../../../utils/text/misc.json"

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage"

//components- reuable
import BIDButton from "../../reusable/BIDButton/BIDButton"

//components
import MediaRetorno from '../../Tweets/media/MediaRetorno'
import DiscussionRetorno from "../../Tweets/discussion/DiscussionRetorno"
import GenderRetorno from "../../Tweets/gender/GenderRetorno"
// eslint-disable-next-line no-unused-vars
import Gender from "../../Tweets/gender/Gender";
import SentimentRetorno from "../../Tweets/sentiment/SentimentRetorno"

//icons
import { CheckSquareFilled, FileFilled, MinusSquareFilled, WarningFilled } from "@ant-design/icons"
import { ReactComponent as ConversationIcon } from "../../../images/icons/conversation.svg";
import { ReactComponent as SentimentIcon } from "../../../images/icons/sentiment.svg";
import { ReactComponent as XenophobiaIcon } from "../../../images/icons/xenophobia.svg";

export default function Migracion({
    selectedCountry,
    countryName,
    countries,
    showSection,
    setMediaImg1,
    setMediaImg2,
    setDiscussionImg,
    setDiscussionImg2,
    setDiscussionImg3,
    setDiscussionImg4,
    setDiscussionImg5,
    setDiscussionImg6,
    setSentimentImg,
    setSentimentImg2,
    setSentimentImg3,
    setSentimentImg4,
    setComparisonImg,
    COUNTRY_OPTIONS,
    handleSelectChange,
    handleDownloadReport,
    isMediosSelected,
    isDiscussionSelected,
    isSentimentSelected,
    isComparisonSelected,
    mediosOnClick,
    discussionOnClick,
    sentimentOnClick,
    comparisonOnClick,


}) {

    const { language } = useCurrentLanguage();

    return (
        <>
        <h1 className="data-page-country-title">
            {
            COUNTRY_OPTIONS.find((co) => selectedCountry === co.code)[
                language === "en" ? "country_text_en" : "country_text"
            ]
            }
        </h1>

        <BIDButton
            text={miscTEXT["downloadLatestReport"][language]}
            type={"light"}
            size={"medium"}
            onClick={handleDownloadReport}
            />

        {/* kpis */}
        <div className="prensa-kpis">
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <FileFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">768</p>
                    <p className="prensa-kpi-increase">+ 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Noticias migratorias</p>
            </div>
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <CheckSquareFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">206</p>
                    <p className="prensa-kpi-decrease">- 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Noticias positivas</p>
            </div>
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <MinusSquareFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">562</p>
                    <p className="prensa-kpi-increase">+ 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Noticias negativas</p>
            </div>
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <WarningFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">34</p>
                    {/* <p className="prensa-kpi-decrease">- 2.5%</p> */}
                </div>
                <p className="prensa-kpi-title">Fuentes</p>
            </div>
        </div>

        <div className="data-page-index">
            <div
            className={
                "data-page-index-button" +
                (isMediosSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <ConversationIcon />
                    {TEXT["volume"][language]}
                </div>
                }
                onClick={mediosOnClick}
            />
            </div>
            <div
            className={
                "data-page-index-button" +
                (isDiscussionSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <XenophobiaIcon />
                    {TEXT["topics"][language]}
                </div>
                }
                onClick={discussionOnClick}
            />
            </div>
            <div
            className={
                "data-page-index-button" +
                (isSentimentSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <SentimentIcon />
                    {TEXT["sentiment"][language]}
                </div>
                }
                onClick={sentimentOnClick}
            />
            </div>
            <div
            className={
                "data-page-index-button" +
                (isComparisonSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <XenophobiaIcon />
                    {TEXT["amplification"][language]}
                </div>
                }
                onClick={comparisonOnClick}
            />
            </div>
        </div>
        <div
            id="sentiment-section"
            className={
            "data-page-section" +
            (showSection("medios") ? "" : " data-page-hidden")
            }
        >
            <div className="data-page-section-title">
            {TEXT["volume"][language]}
            </div>
            <MediaRetorno selectedCountry={selectedCountry} countryName={countryName} countries={countries} countryOptions={COUNTRY_OPTIONS} setImg1={setMediaImg1} setImg2={setMediaImg2}/>
        </div>
        <div
            id="sentiment-section"
            className={
            "data-page-section" +
            (showSection("topics") ? "" : " data-page-hidden")
            }
        >
            <div className="data-page-section-title">
            {TEXT["topics"][language]}
            </div>
            <DiscussionRetorno selectedCountry={selectedCountry} countryName={countryName} countryOptions={COUNTRY_OPTIONS} setImg1={setDiscussionImg} setImg2={setDiscussionImg2} setImg3={setDiscussionImg3} setImg4={setDiscussionImg4} setImg5={setDiscussionImg5} setImg6={setDiscussionImg6}/>
        </div>
        <div
            id="sentiment-section"
            className={
            "data-page-section" +
            (showSection("gender") ? "" : " data-page-hidden")
            }
        >
            <div className="data-page-section-title">
            {TEXT["gender"][language]}
            </div>
            <GenderRetorno selectedCountry={selectedCountry} countryName={countryName} countryOptions={COUNTRY_OPTIONS} setImg1={setDiscussionImg} setImg2={setDiscussionImg2} setImg3={setDiscussionImg3} setImg4={setDiscussionImg4} setImg5={setDiscussionImg5} setImg6={setDiscussionImg6}/>
        </div>
        <div
            id="sentiment-section"
            className={
                "data-page-section" +
                (showSection("sentiment") ? "" : " data-page-hidden")
            }
            >
            <div className="data-page-section-title">
                {TEXT["sentiment"][language]}
            </div>
            <SentimentRetorno selectedCountry={selectedCountry} countryName={countryName} countries={countries} countryOptions={COUNTRY_OPTIONS} setImg1={setSentimentImg} setImg2={setSentimentImg2} setImg3={setSentimentImg3} setImg4={setSentimentImg4}/>
        </div>
            
        </>
    )
}